import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import {IEvl0109pState, IDeptTreeState, IInquiryCndsState, ITargetItemState, IUserItemState} from '../../models/evl/evl0109p_model';
  
const initialState: IEvl0109pState = {
    deptTree : [],
    userList : [],
    targetList : [],
    treeKey : '',
    maxLvlCd : '',

    /* 조회조건 */
    inquiryCnds: {
        deptCd : '',     // 부서코드
        userStCd : 'A'   // 부서상태코드
    },
}

export const evl0109p_Slice = createSlice({
    name: "evl0109p_Slice",
    initialState: initialState,
    reducers: {
        setInquiryCnds: (state, action:PayloadAction<IInquiryCndsState>) => {
            state.inquiryCnds = action.payload;
        },
        setDeptTree: (state, action:PayloadAction<IDeptTreeState[]>) => {
            state.deptTree = action.payload;
        },
        setUserList: (state, action:PayloadAction<IUserItemState[]>) => {
            state.userList = action.payload;
        },
        setTargetList: (state, action:PayloadAction<ITargetItemState[]>) => {
            state.targetList = action.payload;
        },
        setTreeKey: (state, action:PayloadAction<string>) => {
            state.treeKey = action.payload;
        },
        setMaxLvlCd: (state, action:PayloadAction<string>) => {
            state.maxLvlCd = action.payload;
        },
        addTargetList: (state, action:PayloadAction<ITargetItemState>) => {
            const arr : ITargetItemState[] = [...state.targetList];

            const tmpArr = arr.filter((item:ITargetItemState) => {
                return item.apprEmpNo === action.payload.apprEmpNo
            });

            if (tmpArr.length < 1) {
                arr.push(action.payload);
                
                return {
                    ...state,
                    targetList: arr
                }
            } else {
                return {
                    ...state,
                }
            }
        },
    },
});

export default evl0109p_Slice.reducer;
export const Evl0109pAction  = evl0109p_Slice.actions;
export const Evl0109pReducer = evl0109p_Slice.reducer;